<script>
    import dressing from "@intellectability/platform-common";

    import {create_security_error} from "@intellectability/platform-common/utils";
    // common constants
    import {ACTIONS} from "@intellectability/platform-common/constants";

    // common components
    import {
        ChoosePersonModal,
        ExportButtons,
        Icon,
        FlexList
    } from "@intellectability/platform-common/sv";

    // bootstrap
    import {
        Breadcrumb,
        BreadcrumbItem,
    } from "@sveltestrap/sveltestrap";

    import homeVisitsBreadcrumb from "./lib/home-visits-breadcrumb.svg";

    import homeVisitsIcon from "./lib/home-visits-icon.svg";

    const {context = "missing home visits context"} = $props();

    const {
        CHECKLISTS_HOME_VISITS_GLOBAL_LIST,
        CHECKLISTS_HOME_VISITS_PERSON_LIST,
        CHECKLISTS_HOME_VISITS_MANAGE,
        CHECKLISTS_HOME_VISITS_DELETE,
        CHECKLISTS_HOME_VISITS_PDF
    } = ACTIONS;

    let loading = $state(true);
    let fetchingData = $state(false);
    let isLoggedIn = $state(false);

    /**
     * @type {{
     * userActions: number[]
     * businessRules: BusinessRule[]
     * applicationConfig: {[x: string]: string;}
     * userData: Object|false
     }} */
    let userSecurity = $state.raw({
        userActions: [],
        businessRules: [],
        applicationConfig: {},
        userData: false
    });

    // flexlist data
    /** @type {HomeVisitListEntry[]} */
    let homeVisits = $state.raw([]);

    // for dropdowns
    let completedValues = $state.raw([
        {value: "Y", text: "Yes"},
        {value: "N", text: "No"}
    ]);

    // filter options
    let filterForPerson = $state("");
    let filterForVisit_date_fmt = $state("");
    let filterForProvider = $state("");
    let filterForResidential_vendor = $state("");
    let filterForComplete = $state("");
    let filterForUpdated_fmt = $state("");
    let filterForUpdated_by = $state("");

    // action access
    let canManage = $derived(userSecurity.userActions.includes(CHECKLISTS_HOME_VISITS_MANAGE));
    let canDelete = $derived(userSecurity.userActions.includes(CHECKLISTS_HOME_VISITS_DELETE));

    // pagination
    let pagination = $state({
        show: true,
        page: 1,
        limit: 10,
        recordsFiltered: -1,
        recordsTotal: -1,
        pageLengthMenu: [10, 25, 50, 100, 500]
    });

    // sort
    /** @type {{field: string, order: 'asc'|'desc'}} */
    let sort = $state({
        field: "name",
        order: "asc"
    });

    let completedOptions = $derived(completedValues.map(function (option) {
        return {name: option.text, value: option.value};
    }));

    $effect( () => {
        if(!loading && isLoggedIn) {
            fetch_filter_list();
        }
    });

    $effect(function load() {
        dressing.api.get_user_security().then(
            (
                response
            ) => {
                if (response.success === true) {
                    const {business_rules, application_config, logged_in_user, logged_in} = response;

                    const securityData = {
                        businessRules: business_rules || [],
                        userActions: logged_in_user.actions || [],
                        applicationConfig: application_config || {},
                        userData: logged_in_user || false,
                    };

                    isLoggedIn = logged_in;

                    // @ts-ignore;
                    userSecurity = securityData;
                    
                    userSecurity.userData = securityData.userData;
                    userSecurity.applicationConfig = securityData.applicationConfig;
                    userSecurity.businessRules = securityData.businessRules;
                    userSecurity.userActions = securityData.userActions;

                    // user requires access to the CASE NOTES LIST (GLOBAL OR PERSON)
                    if (
                        !securityData.userActions.includes(CHECKLISTS_HOME_VISITS_GLOBAL_LIST) &&
                        !securityData.userActions.includes(CHECKLISTS_HOME_VISITS_PERSON_LIST)
                    ) {
                        const security_error = create_security_error("App.svelte", "HomeVisit",
                        CHECKLISTS_HOME_VISITS_PERSON_LIST);
                        dressing.api.report_security_error(security_error);
                    }

                    loading = false;
                }
            }
        );
    });

    function fetch_filter_list() {
        const filter_query = {
            person: filterForPerson || null,
            visit_date_fmt: filterForVisit_date_fmt || null,
            provider: filterForProvider || null,
            residential_vendor: filterForResidential_vendor || null,
            complete: filterForComplete || null,
            updated_fmt: filterForUpdated_fmt || null,
            updated_by_fmt: filterForUpdated_by || null
        };

        const sort_query = {
            sort: sort.field || null,
            order: sort.order || null
        };

        const page_query = {
            page: pagination.page || null,
            limit: pagination.limit || null
        };
        
        fetchingData = true;

        dressing.get("/cm/home_visits", {
            params: Object.assign(filter_query, {...sort_query, ...page_query})
        }).then(
            ({data: res}) => {
                if (res.success === true) {
                    const {home_visits: array} = res.data;
                    if (Array.isArray(array)) {
                        homeVisits = array;
                        pagination.recordsFiltered = res.data.recordsFiltered;
                        pagination.recordsTotal = res.data.recordsTotal;
                    }
                }
                fetchingData = false;
                loading = false;
            }
        ).catch(function (error) {
            loading = false;
            toast.error("Error fetching home visits list");
        });
    }

    /**
     * @param {string} id
     */
    function deleteHomeVisit(id) {
        if (canDelete === true && id.length) {
            loading = true;
            dressing.axi.delete(`/cm/home_visits/${id}`, {}).then(
                /** @param {{ data: {success:boolean} }} data */({data}) => {
                    if (data.success === true) {
                        fetch_filter_list();
                        toast.success("Home visit deleted successfully");
                    }else {
                        loading = false;
                        toast.error("Error deleting home visit");
                    }
                }
            ).catch(function (error) {
                loading = false;
                toast.error("Error deleting home visit");
            });
        }
    }
    
    /**
     * @param {string} id
     */
    function editHomeVisit(id) {
        if (canManage && id.length > 0) {
            window.location.href = `/index.php?action=${CHECKLISTS_HOME_VISITS_MANAGE}&id=${id}`;
        }
    }

    /**
     * @param {string} id
     */
    function pdfHomeVisit(id) {
        if (canManage && id.length > 0) {
            window.open(`/index.php?action=${CHECKLISTS_HOME_VISITS_PDF}&id=${id}`, "_blank");
        }
    }

    function newHomeVisit(/** @type {{value:string, text:string}} */ person) {
        if (canManage && person?.value.length > 0) {
            // create new home visit
            dressing.post("/cm/home_visits/create", {cons_id: person.value})
                .then(({data, success}) => {
                    if (success === true) {
                        const {home_visit} = data;
                        // redirect to the "newly created" home visit page
                        //console.log(`/index.php?action=${CHECKLISTS_HOME_VISITS_MANAGE}&id=${home_visit.main.id}`);
                        window.location.href = `/index.php?action=${CHECKLISTS_HOME_VISITS_MANAGE}&id=${home_visit.main.id}`;
                    }else {
                        // error creating new home visit
                        toast.error("Error creating new home visit");
                    }
                }).catch(function (error) {
                    // error creating new home visit
                    toast.error("Error creating new home visit");
                });
        }
    }

    /**
     * @param {string} text
     * @returns {string} Yes|No|?
     */
    function getCompletedText(text) {
        if (text === "y" || text === "Y") {
            return "Yes";
        }
        else if (text === "n" || text === "N") {
            return "No";
        }
        else {
            return "?";
        }
    }
</script>

<Breadcrumb divider={" "} class="breadcrumbs mb-3">
    <BreadcrumbItem>Case Management</BreadcrumbItem>
    <BreadcrumbItem class="mx-3">
        <Icon icon="chevron-right"/>
    </BreadcrumbItem>
    <span class="me-2">
        <img src={homeVisitsBreadcrumb} height="13" width="13" alt="page-icon"/>
    </span>
    <BreadcrumbItem>Home Visits</BreadcrumbItem>
</Breadcrumb>
<!-- Page Title -->
<h1>
    <img src={homeVisitsIcon} height="48" width="48" alt="page-icon"/>
    Home Visits
</h1>
<!-- Export Buttons -->
<div class="d-flex w-100 justify-content-end mb-3">
    <ExportButtons
            show={["excel", "pdf"]}
            href="ajax/default/ajax.download_list.php?list={CHECKLISTS_HOME_VISITS_GLOBAL_LIST}"
    />
</div>
<!-- TABLE -->
<FlexList
        {loading}
        pagerConfig={pagination}
        onpagechange={(/** @type {number} */ page) => (pagination.page = page)}
        onsort={(/** @type {string} */ field, /** @type {'asc'|'desc'} */ order) => {
            sort = { field, order };
        }}
        onpagelengthchange={(/** @type {number} */ newLimit) => (pagination.limit = newLimit)}
        columns={[
        {
            name: "Person",
            field: "name",
            width: "",
            sortedBy: sort.field === "name" ? sort.order : "",
            sortable: true,
            collapse: false, // do not hide when in mobile view
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (/** @type {string} */ value) {
                filterForPerson = value;
            }
        },
        {
            name: "Visit Date",
            field: "visit_date_fmt",
            width: "",
            sortedBy: sort.field === "visit_date_fmt" ? sort.order : "",
            sortable: true,
            collapse: false,
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (/** @type {string} */ value) {
                filterForVisit_date_fmt = value;
            },
        },
        {
            name: "Home Provider",
            field: "provider",
            width: "",
            sortedBy: sort.field === "provider" ? sort.order : "",
            sortable: true,
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (/** @type {string} */ value) {
                filterForProvider = value;
            },
        },
        {
            name: "Residential Vendor",
            field: "residential_vendor",
            width: "",
            sortable: true,
            sortedBy: sort.field === "residential_vendor" ? sort.order : "",
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (/** @type {string} */ value) {
                filterForResidential_vendor = value;
            },
        },
        {
            name: "Complete",
            field: "complete",
            width: "",
            cell: completedText,
            sortable: true,
            sortedBy: sort.field === "complete" ? sort.order : "",
            filterType: "select",
            filterOptions: completedOptions,
            onfilter: function (/** @type {string} */ value) {
                filterForComplete = value;
            },
        },
        {
            name: "Last Updated",
            field: "updated_fmt",
            width: "",
            sortable: true,
            sortedBy: sort.field === "updated_fmt" ? sort.order : "",
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (/** @type {string} */ value) {
                filterForUpdated_fmt = value;
            },
        },
        {
            name: "Last Updated By",
            field: "updated_by_fmt",
            width: "",
            sortable: true,
            sortedBy: sort.field === "updated_by_fmt" ? sort.order : "",
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (/** @type {string} */ value) {
                filterForUpdated_by = value;
            },
        },
        {
            name: "Actions",
            width: "110px",
            buttons: [
                {
                    icon: "file-pdf",
                    tooltip: "Generate PDF",
                    variant: "neutral",
                    className: "btn p-1 border-0 shadow-none",
                    styles: "",
                    action: function (event, row) {
                        const { id } = row;
                        pdfHomeVisit(id);
                    }
                },
                {
                    icon: "pencil",
                    tooltip: "Edit",
                    variant: "neutral",
                    className: "btn p-1 border-0 shadow-none",
                    styles: "",
                    action: function (event, row) {
                        const { id } = row;
                        editHomeVisit(id);
                    },
                    disabled: function (row) {
                        return (canManage && row.allow_edit === "Y") === false;
                    }
                },
                {
                    icon: "times-circle",
                    tooltip: "Delete visit",
                    variant: "danger",
                    className: "btn link-danger border-0 p-1 shadow-none",
                    action: function (event, row) {
                        const { id } = row;
                        deleteHomeVisit(id);
                    },
                    disabled({allow_edit}) {
                        return (canDelete && allow_edit === "Y") === false;
                    }
                },
            ],
        },
    ]} data={homeVisits}></FlexList>

<div class="mb-5">
    {#if canManage}
        <ChoosePersonModal context="home_visits" onselect={newHomeVisit} confirmButtonText="Create New Home Visit"/>
    {/if}
</div>

{#snippet completedText(
    /** @type object */ row,
    /** @type string */ field,
    /** @type object */ column
)}
    {getCompletedText(row[field])}
{/snippet}